import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import NomineeCard from './NomineeCard';
import OtherCard from './OtherCard';
export default class CategoryCard extends Component {
  view() {
    const category = this.attrs.category;
    const award = this.attrs.award;
    const nominees = category.nominees() || [];
    const nomineeCount = nominees.length;

    // Calculate user's votes in this category
    const categoryId = category.id();
    const currentUserId = app.session.user?.id();
    const userVotes = app.store.all('award-votes').filter(v => {
      const vUserId = v.userId?.() || v.data?.relationships?.user?.data?.id;
      return !vUserId || String(vUserId) === String(currentUserId);
    });
    const votesInCategory = userVotes.filter(v => {
      const vCategoryId = v.categoryId?.() || v.data?.relationships?.category?.data?.id;
      return String(vCategoryId) === String(categoryId);
    });
    const userVoteCount = votesInCategory.length;
    const votesLimit = parseInt(app.forum.attribute('awardsVotesPerCategory') || '1', 10);
    const isVotingOpen = award.isVotingOpen();
    const showVoteBadge = isVotingOpen && app.session.user && userVoteCount > 0;
    return m("div", {
      className: "CategoryCard",
      id: `category-${category.id()}`
    }, m("div", {
      className: "CategoryCard-header"
    }, m("div", {
      className: "CategoryCard-headerMain"
    }, m("h2", null, category.name()), category.description() ? m("p", null, category.description()) : null), m("div", {
      className: "CategoryCard-badges"
    }, showVoteBadge ? m("div", {
      className: "CategoryCard-voteBadge"
    }, m("i", {
      className: "fas fa-check"
    }), votesLimit === 0 ? app.translator.trans('huseyinfiliz-awards.forum.category.votes_unlimited', {
      count: userVoteCount
    }) : app.translator.trans('huseyinfiliz-awards.forum.category.votes_used', {
      used: userVoteCount,
      limit: votesLimit
    })) : null, nomineeCount > 0 ? m("div", {
      className: "CategoryCard-badge"
    }, app.translator.trans('huseyinfiliz-awards.forum.category.nominees_count', {
      count: nomineeCount
    })) : null)), m("div", {
      className: "CategoryCard-grid"
    }, nominees.map(nominee => m(NomineeCard, {
      nominee: nominee,
      category: category,
      award: award
    })), category.allowOther() && award.isVotingOpen() && app.session.user ? m(OtherCard, {
      category: category
    }) : null), nominees.length === 0 && !category.allowOther() ? m("div", {
      className: "EmptyState"
    }, m("p", null, app.translator.trans('huseyinfiliz-awards.forum.empty.no_nominees'))) : null);
  }
}
flarum.reg.add('huseyinfiliz-awards', 'forum/components/CategoryCard', CategoryCard);